import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Nav from "@/components/Nav";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [state, setState] = useState("verifying");

  useEffect(() => {
    if (!token) { setState("missing"); return; }
    api.post("/auth/email/verify/confirm", { token })
      .then(() => setState("ok"))
      .catch(e => setState("fail"));
  }, [token]);

  return (
    <div><Nav />
      <div className="max-w-md mx-auto px-5 py-16 text-center">
        {state === "verifying" && <p className="text-slate-400">Verifying your email…</p>}
        {state === "ok" && (
          <>
            <h1 className="font-serif text-3xl mb-2" data-testid="verify-ok">Email verified</h1>
            <p className="text-slate-400 mb-5">Thanks — you'll now receive secure account and report notifications.</p>
            <button onClick={()=>nav("/dashboard")} className="px-5 py-3 rounded-xl bg-[#E0A96D] text-[#070C18] font-semibold hover:bg-[#F0C28B]">Go to dashboard</button>
          </>
        )}
        {state === "fail" && <p className="text-rose-300" data-testid="verify-fail">This verification link is invalid or expired.</p>}
        {state === "missing" && <p className="text-slate-400">Missing verification token.</p>}
      </div>
    </div>
  );
}
